import {IDS} from '../assessment-reports-action-id.constants';
import * as DocumentListActions from './list.actions';
import { saveAs } from 'file-saver';
import get from "lodash/get";
import {TYPES as ACC_TYPES} from "../../accreditation-action-type.constants";
import {GRID_FILTER} from "../../../../common/grid/grid.constants";
import {TAB_SHOW} from "../../../../common/tabs/tabs.constants";
import {removeAssessmentReport} from "./list.actions";

/**
 * Creates a new DocumentListController.
 * @class
 */
class DocumentListController {
    constructor($ngRedux,
                $uiRouterGlobals,
                $state,
                $stateParams,
                $scope,
                $rootScope,
                $filter,
                $timeout,
                $mdSidenav,
                $mdDialog,
                Notifier,
                DocumentManager,
                DocumentService,
                AccreditationService,
                NavigationService,
                AccreditationDocumentsService,
                EmployeeService,
                AuthService,
                FileActions
    ) {
        this.$ngRedux = $ngRedux;
        this.$uiRouterGlobals = $uiRouterGlobals;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$mdSidenav = $mdSidenav;
        this.$mdDialog = $mdDialog;
        this.Notifier = Notifier;
        this.DocumentManager = DocumentManager;
        this.DocumentService = DocumentService;
        this.AccreditationService = AccreditationService;
        this.NavigationService = NavigationService;
        this.AccreditationDocumentsService = AccreditationDocumentsService;
        this.EmployeeService = EmployeeService;
        this.AuthService = AuthService;
        this.FileActions = FileActions;

        this.hideRemoveButton = (AuthService.isManager() === false);

        this.schemeCode = this.$stateParams.itemCode;

        this.identifier  = IDS.accAssessmentReports;
        this.parentState = IDS.app_accreditation_scheme_assessment_reports;
        this.state       = IDS.app_accreditation_scheme_assessment_reports_list;
        this.title       = this.$filter('translate')('ACCREDITATION.ASSESSMENT_REPORTS.LIST.TAB');
    }

    $onInit() {
        this.unsubscribe = this.$ngRedux.connect(state => {
            const accAssessmentReports   = state.accreditation.accAssessmentReports;
            const {siteLocation, headOffice, year} = state.accreditation.accDashboardLocationYear;
            return {
                fiscalYearStart:    accAssessmentReports.fiscalYearStart,
                sloQualityManagers: accAssessmentReports.sloQualityManagers,
                siteLocation:       siteLocation || accAssessmentReports.siteLocationUuid,
                siteLocationName:   accAssessmentReports.siteLocationName,
                headOffice,
                fiscalYear: year,
            }
        }, {...this.FileActions, ...DocumentListActions})(this);

        // const accDocumentId = this.$stateParams.ado;
        // const fiscalYear = this.$stateParams.year;
        const navConfig = this.NavigationService.getConfig(this.$state.$current);
        this.colorName = navConfig.colorName;

        const ctrl = this;
        this.fetchframeworkDetails(this.schemeCode).then(scheme => {
            ctrl.title = scheme.name;
            ctrl.schemeId = scheme.id;
        });

        this.unsubscribeLocationChange = this.$scope.$on('LOCATION_SUBJECT_SELECTED', this.onLocationChange.bind(this));
        this.unsubscribeSelectCascadeLoaded = this.$scope.$on('SELECT_CASCADE_SUBJECTS_LOADED', this.onSelectCascadeLoaded.bind(this));
        this.unsubscribeLocationNotFound = this.$scope.$on('LOCATION_SUBJECT_NOT_FOUND', this.onLocationNotFound.bind(this));
    }

    onSelectCascadeLoaded() {
        if(this.headOffice && this.siteLocation) {
            this.$rootScope.$broadcast('FORCE_SELECT_PARENT', 0, this.headOffice, this.siteLocation);
        }
        else {
            if(this.$stateParams.slo) {
                const siteLocation = this.$stateParams.slo;
                this.EmployeeService.getEmploymentLocations(siteLocation).then(result => {
                    const headOffice = result[0].uuid;
                    this.$rootScope.$broadcast('FORCE_SELECT_PARENT', 0, headOffice, siteLocation );
                })
            }
            if(this.$stateParams.year){
                this.$ngRedux.dispatch({
                    type: ACC_TYPES.LOCATION_SEARCH_BAR_CHANGE,
                    accDashboardLocationYear: {
                        year: this.$stateParams.year,
                    }
                });
            }
        }
    }

    onLocationChange (evt, loc) {
        const subjectType = get(loc,'in_subject_basic_type_code');
        switch(subjectType){
            case 'hof':
                this.$ngRedux.dispatch({
                    type: ACC_TYPES.LOCATION_SEARCH_BAR_CHANGE,
                    accDashboardLocationYear: {
                        headOffice: loc.in_subject_uuid,
                    }
                });
                break;

            case 'slo':
                this.$stateParams.slo = loc.in_subject_uuid;
                this.$ngRedux.dispatch({
                    type: ACC_TYPES.LOCATION_SEARCH_BAR_CHANGE,
                    accDashboardLocationYear: {
                        siteLocation: loc.in_subject_uuid,
                        year: this.$stateParams.year,
                    }
                });
                this.fetchSiteLocationDetails( loc.in_subject_uuid );
                break;
        }
    };

    onLocationNotFound(event, location) {
        this.hideSelectSiteLocation = true;
        var user = this.AuthService.getUser();
        if(user.parentCount !== 1)
            return

        const ctrl = this;
        this.EmployeeService.getEmploymentLocations(user.uuid).then(siteLocations => {
            const siteLocation = get(siteLocations,'[0].uuid');
            this.$stateParams.slo = siteLocation;
            this.$ngRedux.dispatch({
                type: ACC_TYPES.LOCATION_SEARCH_BAR_CHANGE,
                accDashboardLocationYear: {
                    siteLocation,
                }
            });
            ctrl.fetchSiteLocationDetails( siteLocation ).then(()=>{
                ctrl.$rootScope.$broadcast('LOCATION_SUBJECT_SELECTED', {
                    in_subject_basic_type_code: 'slo',
                    in_subject_uuid: siteLocation
                });
            })
        });
    }

    onYearChange({item}) {
        const year = item.value;
        this.$stateParams.year = year;
        this.$ngRedux.dispatch({
            type: ACC_TYPES.LOCATION_SEARCH_BAR_CHANGE,
            accDashboardLocationYear: { year }
        });
        this.$ngRedux.dispatch({
            type: GRID_FILTER,
            id: IDS.accAssessmentReports,
            path: IDS.accAssessmentReportsGrid,
            filter: {fiscal_year: year}
        })
    }

    onRemove({item}) {
        this.removeAssessmentReport({vdo_uuid: item.vdo_uuid});
    }

    onDownload({item}) {
        this.download(`storage${item.doc_url}`);
    }

    downloadDocuments (filter, documentCode, documentTypes) {
        const ctrl = this;
        const params = {
            acc_code:   this.schemeCode,
            loc_uuid:   this.siteLocation,
            year:       this.fiscalYear
        }
        this.DocumentService.fetchDocumentToken("ado", params).then(function (response) {
            ctrl.downloadButtonDisabled = true;
            ctrl.DocumentService.downloadZip(response.data.token).then(response => {
                const filename = [
                    ctrl.siteLocationName,
                    ctrl.schemeCode,
                    ctrl.fiscalYear,
                    Date.now()
                ].join('_');
                saveAs(new Blob([response.data], {type: "octet/stream"}), `${filename}.zip`);
                ctrl.Notifier.success('Download archive completed!');
                ctrl.downloadButtonDisabled = false;
            }, function (error) {
                ctrl.Notifier.error("Error downloading archive!");
                ctrl.downloadButtonDisabled = false;
            });
        }, function (error) {
            ctrl.$scope.cursorState = 'default';
            ctrl.Notifier.error("Error fetching documents list! Archive is too big!");
            ctrl.downloadButtonDisabled = false;
        });
    }

    addDocument() {
        // this.$state.go(IDS.app_accreditation_scheme_assessment_reports_add, {itemCode: this.schemeCode});
        this.$ngRedux.dispatch({
            type: TAB_SHOW,
            id: IDS.app_accreditation_scheme_assessment_reports,
            state: IDS.app_accreditation_scheme_assessment_reports_add,
            stateParams:{
                itemCode: this.schemeCode,
            },
        })
    }

    $onDestroy() {
        this.unsubscribe();
        this.unsubscribeLocationChange();
        this.unsubscribeSelectCascadeLoaded();
        this.unsubscribeLocationNotFound();
    }

}

DocumentListController.$inject = [
    '$ngRedux',
    '$uiRouterGlobals',
    '$state',
    '$stateParams',
    '$scope',
    '$rootScope',
    '$filter',
    '$timeout',
    '$mdSidenav',
    '$mdDialog',
    'Notifier',
    'DocumentManager',
    'DocumentService',
    'AccreditationService',
    'NavigationService',
    'AccreditationDocumentsService',
    'EmployeeService',
    'AuthService',
    'FileActions'
]

export const accAssessmentReports = {
    bindings: {},
    controller: DocumentListController,
    template: `
        <div layout-gt-xs="row" layout-align="center center">
            <div class="formHeader" flex>
                <h3>
                    <asset cls="colorAccreditations" src="accreditation_polices_procedures.svg"></asset>{{$ctrl.title}}
                </h3>
            </div>
            
<!--        <md-button class="btnDefault" ng-disabled="$ctrl.downloadButtonDisabled" ng-click="$ctrl.downloadDocuments()">Download All Documents</md-button>-->
        </div>
        <form name="selectSiteLocationForm" novalidate>
            <div ng-if="$ctrl.schemeId"  ng-hide="$ctrl.hideSelectSiteLocation" layout-gt-sm="row" flex>           
                <div layout-gt-sm="row">
                    <select-cascade
                        identifier="{{$ctrl.identifier}}"
                        purpose="'acc'"
                        max="slo"
                        scheme="{{$ctrl.$stateParams.itemCode}}"
                        preselected
                        behaviour="'selectDefault'">
                    </select-cascade>
                </div>
<!--                <input-select-->
<!--                        flex-gt-sm="10"-->
<!--                        label="{{'COMMON.DATE.YEAR' | translate}}"-->
<!--                        identifier="{{$ctrl.identifier}}"-->
<!--                        state-module="accreditation"-->
<!--                        state-path="selectedYear"-->
<!--                        state-data="availableYears"-->
<!--                        on-change="$ctrl.onYearChange($event)">-->
<!--                </input-select> -->
            </div>
        </form>
        <acc-assessment-reports-grid
            ng-show="$ctrl.siteLocation"
            title="$ctrl.title"
            on-select="$ctrl.onSelect($event)"
            on-download="$ctrl.onDownload($event)"
            on-remove="$ctrl.onRemove($event)">
        </acc-assessment-reports-grid>
        <md-button class="btnDefault" ng-click="$ctrl.addDocument()">Add Assessment Report</md-button>
        <tabs-navigation
            identifier="{{$ctrl.parentState}}"
            state="{{$ctrl.state}}">
        </tabs-navigation>`,
}
